import React from "react";
import SliderPanel from "../SliderPanel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle, faTimes } from "@fortawesome/pro-light-svg-icons";
import { Button, Col, Nav, Row, Tab } from "react-bootstrap";
import { SourceSplitupContainer } from "../../containers";
import "../../styles/components/SourceSplitupSlider.scss";
const SourceSplitupSlider = (props) => {
  const {
    sourcesplitupslide,
    setsourcesplitupslide,
    sourceSplit,
    activeIndex,
    setActiveIndex,
    values,
  } = props;

  return (
    <SliderPanel
      isOpen={sourcesplitupslide}
      size="75"
      showCancel={false}
      backdropClicked={() => setsourcesplitupslide(false)}
    >
      <div>
        <div className="disp-flex-row justify-content-space-between dark-grey-color fw-500 ft-16">
          <p>Source Wise Splitups</p>
          <FontAwesomeIcon
            icon={faTimes}
            style={{ cursor: "pointer" }}
            onClick={() => setsourcesplitupslide(false)}
          />
        </div>
        <div className="Border-line W-100 pl-15">
          <Tab.Container id="left-tabs-example" defaultActiveKey={0}>
            <Row>
              <Col className="background-color-white m-0-p-0">
                <div className="Border-inline align-items-center justify-content-center">
                  <p className="ft-14 fw-600 black padding-header">
                    Source Name
                  </p>
                </div>
                <Nav variant="pills" className="d-flex flex-col m-15 p-0 W-100">
                  {sourceSplit?.sourceSplit?.map((data, index) => (
                    <Nav.Item className="m-0-p-0 W-100">
                      <Nav.Link
                        eventKey={index}
                        style={{
                          color: index == activeIndex ? "#307bf6" : "#3b3b3b",
                          backgroundColor:
                            index == activeIndex ? "white" : "#F0F0F0",
                          borderLeft:
                            index == activeIndex ? "2px solid #307bf6" : "none",
                        }}
                        onClick={() => setActiveIndex(index)}
                      >
                        {data?.sourceName}
                      </Nav.Link>
                    </Nav.Item>
                  ))}
                </Nav>
              </Col>
              <Col sm={9}>
                <Tab.Content>
                  {sourceSplit?.sourceSplit?.map((data, index) => (
                    <Tab.Pane eventKey={index}>
                      {/* <h2>{data.source}</h2> */}
                      <SourceSplitupContainer
                        data={data}
                        values={values}
                        module={"distribution"}
                      />
                    </Tab.Pane>
                  ))}
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </div>
      </div>
    </SliderPanel>
  );
};

export default SourceSplitupSlider;
